import { has } from 'lodash'
import globalLang from './global_lang'
import bloggerLang from './blogger_lang'
import errLang from './err_lang'
import kbankLang from './kbank_lang'
import the1Lang from './the1_lang'
import branchLang from './branches_lang'
import checkoutLang from './checkout_lang'
import addressLang from './address_lang'

export function isLangKeyExisted(key) {
    return has(globalLang, key) ||
        has(bloggerLang, key) ||
        has(errLang, key) ||
        has(kbankLang, key) ||
        has(the1Lang, key) ||
        has(branchLang, key) ||
        has(checkoutLang, key) ||
        has(addressLang, key)
}